import { userSegRedirectEntrypoint } from '@jira/redirect-entrypoints__user-seg-redirect/src/userSegRedirectEntrypoint.entrypoint.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { calendarEntryPoint } from '@jira/spa-apps__business-calendar-new/src/calendarEntryPoint.entrypoint.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getProjectViewResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { businessProjectLayout } from '@jira/platform__layouts-business-project-layout/src/index.tsx';
import { ThemedLazySkeleton } from '@jira/platform__project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jiraBusinessCalendarRoute } from '@jira/router-routes__business-calendar-routes/src/jiraBusinessCalendarRoute.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { jiraHorizontalNavEntrypoint } from '@jira/navigation-apps__horizontal-nav-jira/src/jiraHorizontalNavEntrypoint.entrypoint.tsx';
import type { Route } from '@atlassian/react-resource-router';

const calendarPageEntrypoint = createPageEntryPoint({
	main: calendarEntryPoint,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
	redirect: userSegRedirectEntrypoint,
});

export const jiraBusinessCalendarRouteEntry: Route = createEntry(jiraBusinessCalendarRoute, () => ({
	group: 'classic-business',
	ufoName: 'jwm.calendar-view',

	entryPoint() {
		return calendarPageEntrypoint;
	},

	layout: businessProjectLayout,
	skeleton: ThemedLazySkeleton,

	navigation: {
		menuId: MenuIdProjects,
		horizontal: AsyncHorizontalNavJira,
	},

	resources: getProjectViewResources(),
	supportsPreviewPanel: true,
	supportsProjectTheme: 'full',

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
